import { useEffect, useState } from "react";
import { useDispatchApp } from "../../lib/redux";
import { startGetAdvertiserDefaultPlatformValues } from "../../actions/platformDefaults";

const toPlatformsKey = (platforms) =>
  Array.isArray(platforms) ? platforms.filter(Boolean).join(",") : "";

/**
 * Loads advertisersDefaultPlatformValues for one or more Settings platform keys.
 */
export const useAdvertiserPlatformDefaults = ({
  platforms = [],
  enabled = true,
} = {}) => {
  const dispatch = useDispatchApp();
  const platformsKey = toPlatformsKey(platforms);
  const [platformDefaults, setPlatformDefaults] = useState({});
  const [loadedKey, setLoadedKey] = useState("");

  useEffect(() => {
    let isMounted = true;

    if (!enabled || !platformsKey) {
      setPlatformDefaults({});
      setLoadedKey("");
      return () => {
        isMounted = false;
      };
    }

    const loadPlatformDefaults = async () => {
      const results = await Promise.all(
        platformsKey.split(",").map(async (platform) => {
          const result = await dispatch(
            startGetAdvertiserDefaultPlatformValues({ platform })
          );
          return { platform, result };
        })
      );

      if (!isMounted) {
        return;
      }

      const nextDefaults = results.reduce((acc, { platform, result }) => {
        if (result?.ok && result.data) {
          acc[platform] = result.data;
        }
        return acc;
      }, {});

      setPlatformDefaults(nextDefaults);
      setLoadedKey(platformsKey);
    };

    loadPlatformDefaults();

    return () => {
      isMounted = false;
    };
  }, [dispatch, enabled, platformsKey]);

  return {
    platformDefaults,
    isLoaded: enabled && Boolean(platformsKey) && loadedKey === platformsKey,
  };
};

export default useAdvertiserPlatformDefaults;
